/**
 * Trainova AI — Spanish (Español) Locale Dictionary
 */

export const es: Record<string, string> = {
  // Navigation & Header
  'nav.brand': 'Trainova AI',
  'nav.dashboard': 'Panel Principal',
  'nav.simulations': 'Simulaciones',
  'nav.scenarios': 'Escenarios',
  'nav.courses': 'Cursos',
  'nav.my_attempts': 'Mis Intentos',
  'nav.assessments': 'Evaluaciones',
  'nav.reports': 'Informes',
  'nav.analytics': 'Analítica',
  'nav.settings': 'Configuración',
  'nav.admin_console': 'Consola de Administración',
  'nav.tenant_settings': 'Configuración de Organización',
  'nav.sign_out': 'Cerrar Sesión',
  'nav.profile': 'Perfil',
  'nav.language': 'Idioma',
  'nav.menu': 'Menú',
  'nav.close': 'Cerrar',
  'nav.home': 'Inicio',
  'nav.my_results': 'Mis Resultados',
  'nav.learners': 'Estudiantes',
  'nav.users': 'Usuarios',

  // Authentication & Login
  'auth.sign_in': 'Iniciar Sesión',
  'auth.welcome_back': 'Iniciar sesión en Trainova',
  'auth.sign_in_subtitle': 'Inicia sesión para acceder a tu espacio de simulación con IA',
  'auth.sign_in_to_org': 'Iniciar sesión en {{org}}',
  'auth.org_portal_welcome': 'Bienvenido al portal de la organización {{org}}.',
  'auth.single_tenant_workspace': 'Espacio de trabajo de inquilino único',
  'auth.change_org': 'Cambiar',
  'auth.change_org_title': 'Cambiar a inicio de sesión predeterminado',
  'auth.locked_by_url': 'Bloqueado por URL',
  'auth.studio_badge': 'Estudio de Simulación con IA',
  'auth.quick_demo_access': 'Acceso Rápido de Demostración',
  'auth.demo_role_selector_aria': 'Selector de rol de demostración',
  'auth.role_learner': 'Aprendiz',
  'auth.role_admin': 'Administrador',
  'auth.role_super_admin': 'Superadministrador',
  'auth.email_label': 'Correo Electrónico / ID de Usuario',
  'auth.email_placeholder': 'learner@enterprise.com',
  'auth.password_label': 'Contraseña',
  'auth.password_placeholder': '••••••••••••',
  'auth.show_password_aria': 'Mostrar contraseña',
  'auth.hide_password_aria': 'Ocultar contraseña',
  'auth.tenant_slug_label': 'Dominio de Organización (Slug)',
  'auth.tenant_slug_placeholder': 'ej. demo-trainova',
  'auth.remember_me': 'Recordar este dispositivo',
  'auth.forgot_password': '¿Olvidaste tu contraseña?',
  'auth.signing_in': 'Iniciando sesión...',
  'auth.submit_sign_in': 'Entrar al Portal',
  'auth.submit_sign_in_to_org': 'Iniciar sesión en {{org}}',
  'auth.entering_portal': 'Entrando a Trainova.ai…',
  'auth.bottom_note': 'Portal de evaluación empresarial · Cuentas creadas por su administrador',
  'auth.switch_account': 'Cambiar Cuenta',
  'auth.logged_in_as': 'Conectado como {{name}}',
  'auth.login_error': 'Correo o contraseña incorrectos. Inténtalo de nuevo.',
  'auth.session_expired': 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.',
  'auth.err_required': 'Por favor, ingrese su correo electrónico y contraseña.',
  'auth.err_invalid_credentials': 'Correo o contraseña no válidos. Verifique sus credenciales o haga clic en un rol de demostración arriba.',
  'auth.err_login_failed': 'Error al iniciar sesión. Verifique sus credenciales.',
  'auth.err_unexpected': 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.',
  'auth.reset_password_title': 'Restablecer contraseña',
  'auth.reset_password_msg': 'Las instrucciones para restablecer la contraseña se han enviado a su correo electrónico.',

  // Auth & Branding Panel (.auth-brand)
  'auth.brand_tagline_main': 'Practica la conversación',
  'auth.brand_tagline_em': 'antes de que sea real.',
  'auth.brand_lede': 'Ensaya llamadas de clientes con personajes de IA, obtén calificaciones en cada competencia y demuestra que estás listo.',
  'auth.brand_sim_who_name': 'Priya Sharma · Cliente',
  'auth.brand_sim_who_desc': 'FinTech · Cargo de tarjeta disputado · Servicio',
  'auth.brand_sim_live': 'Práctica',
  'auth.brand_sim_cust_role': 'Cliente',
  'auth.brand_sim_cust_msg': '¡Me han cobrado dos veces por el mismo pedido y nadie me ha ayudado en tres días!',
  'auth.brand_sim_me_role': 'Tú (Aprendiz)',
  'auth.brand_sim_me_msg': 'Entiendo su frustración, Priya. Permítame revisar ambas transacciones e investigar ahora mismo.',
  'auth.brand_sim_meter_empathy': 'Empatía',
  'auth.brand_sim_meter_resolution': 'Resolución',
  'auth.brand_sim_meter_readiness': 'Preparación',
  'auth.brand_flow_practice': 'Práctica',
  'auth.brand_flow_assess': 'Evaluar',
  'auth.brand_flow_coach': 'Entrenar',
  'auth.brand_flow_prove': 'Demostrar Preparación',

  // Auth Layout Topline & Footer
  'auth.org_logo_alt': 'Logotipo de la organización',
  'auth.footer_copyright': '© 2026 Trainova AI Inc.',
  'auth.footer_privacy': 'Política de Privacidad',
  'auth.footer_terms': 'Términos de Servicio',
  'auth.footer_support': 'Soporte',

  // Login Gateway Transition
  'gateway.security_auth_title': 'Seguridad y Autenticación',
  'gateway.security_auth_sub': 'Verificando tokens de sesión',
  'gateway.tenant_gateway_title': 'Puerta de Enlace de Inquilino',
  'gateway.tenant_gateway_sub_workspace': 'Espacio de trabajo {{tenant}}',
  'gateway.tenant_gateway_sub_default': 'Inquilino empresarial',
  'gateway.ai_core_title': 'Núcleo de Personajes de IA',
  'gateway.ai_core_sub': 'Sincronizando simulaciones y modelos',
  'gateway.ready_title': 'Listo',
  'gateway.ready_sub': 'Lanzando portal',
  'gateway.welcome_back': '¡Bienvenido de nuevo, {{name}}!',
  'gateway.entering_portal': 'Entrando al Portal…',
  'gateway.status_authenticating': 'Autenticando sesión…',
  'gateway.status_connecting': 'Conectando al espacio de trabajo…',
  'gateway.status_preparing': 'Cargando motores de simulación con IA…',
  'gateway.status_ready': '¡Listo! Lanzando panel de control…',

  // Dashboard
  'dashboard.greeting': 'Bienvenido de nuevo, {{name}}',
  'dashboard.subtitle': 'Practica simulaciones de alta exigencia con personajes de IA realistas.',
  'dashboard.assigned_simulations': 'Simulaciones Asignadas',
  'dashboard.practice_simulations': 'Explorar y Practicar Escenarios',
  'dashboard.recent_attempts': 'Intentos Recientes',
  'dashboard.stats_completed': 'Simulaciones Completadas',
  'dashboard.stats_avg_score': 'Puntuación Media',
  'dashboard.stats_hours_practiced': 'Tiempo de Práctica',
  'dashboard.stats_readiness': 'Preparación para el Rol',
  'dashboard.view_all': 'Ver Todo',
  'dashboard.start_simulation': 'Iniciar Simulación',
  'dashboard.resume_attempt': 'Reanudar Intento',
  'dashboard.view_results': 'Ver Resultados',
  'dashboard.no_assigned': 'No tienes simulaciones asignadas en este momento.',
  'dashboard.no_attempts': 'Aún no hay intentos de simulación registrados.',

  // Scenario Briefing & System Check
  'briefing.title': 'Instrucciones del Escenario',
  'briefing.overview': 'Contexto y Situación',
  'briefing.objectives': 'Objetivos de Aprendizaje y Competencias',
  'briefing.persona': 'Información del Personaje de IA',
  'briefing.role': 'Rol del Personaje',
  'briefing.temperament': 'Temperamento y Comportamiento',
  'briefing.hardware_check': 'Comprobación de Dispositivos',
  'briefing.mic_status': 'Micrófono',
  'briefing.camera_status': 'Cámara (Opcional)',
  'briefing.audio_status': 'Altavoces / Audio',
  'briefing.testing_mic': 'Habla al micrófono para probar el volumen...',
  'briefing.mic_ready': 'El micrófono está activo y listo',
  'briefing.mic_permission_needed': 'Se requiere permiso de micrófono para continuar',
  'briefing.allow_mic': 'Permitir Acceso al Micrófono',
  'briefing.retry_mic': 'Reintentar Micrófono',
  'briefing.consent_title': 'Consentimiento de Grabación y Evaluación por IA',
  'briefing.consent_body': 'Esta sesión se grabará y transcribirá para la evaluación automatizada de competencias. Los datos de audio y video se mantienen aislados de forma segura dentro de tu organización.',
  'briefing.consent_checkbox': 'Entiendo y acepto la grabación de la sesión y la evaluación por IA.',
  'briefing.start_simulation_btn': 'Entrar a la Sala de Simulación',
  'briefing.preparing_room': 'Configurando personaje de IA y escenario de audio...',

  // Simulation Room & Conversation Controls
  'simulation.live_title': 'Sesión de Simulación con IA en Vivo',
  'simulation.persona_speaking': 'El personaje de IA está hablando...',
  'simulation.listening_user': 'Escuchando... Habla con naturalidad',
  'simulation.connecting': 'Estableciendo conexión de audio segura...',
  'simulation.paused': 'Simulación en pausa',
  'simulation.mute_mic': 'Silenciar Micrófono',
  'simulation.unmute_mic': 'Activar Micrófono',
  'simulation.finish_session': 'Finalizar Sesión',
  'simulation.retry': 'Reintentar Simulación',
  'simulation.turn_count': 'Turno {{current}}',
  'simulation.timer': 'Tiempo de Sesión',
  'simulation.transcript_title': 'Transcripción en Tiempo Real',
  'simulation.transcript_empty': 'La conversación aparecerá aquí a medida que hables.',
  'simulation.confirm_finish_title': '¿Finalizar y enviar simulación?',
  'simulation.confirm_finish_body': '¿Estás seguro de que deseas concluir esta simulación? Se enviará inmediatamente para su evaluación con IA.',
  'simulation.confirm_cancel': 'Continuar Simulación',
  'simulation.confirm_submit': 'Enviar para Evaluación',
  'simulation.evaluating_title': 'Evaluando rendimiento de la conversación...',
  'simulation.evaluating_subtitle': 'Analizando empatía, resolución, cumplimiento y manejo de objeciones.',

  // Autoplay & Voice Interaction Alerts
  'simulation.autoplay_blocked_banner': 'Haga clic en cualquier lugar o toque Reproducir voz para activar el audio de la IA',
  'simulation.play_audio_btn': 'Reproducir voz',

  // Microphone & Hardware Alerts in Simulation
  'simulation.mic_blocked_title': 'Acceso al micrófono bloqueado',
  'simulation.mic_blocked_banner': 'El acceso al micrófono está bloqueado por su navegador. Haga clic en el icono de candado/ajustes en la barra de direcciones para permitir el acceso, o cambie al modo de texto.',
  'simulation.mic_blocked_help': 'Para permitir: Haga clic en el icono 🔒 o 🎛️ junto a la URL en la barra de direcciones, configure el micrófono en "Permitir" y haga clic en Reintentar micrófono.',
  'simulation.mic_help_btn': 'ℹ️ ¿Cómo permitir?',
  'simulation.retry_mic': 'Reintentar micrófono',
  'simulation.use_text_mode': 'Usar modo de texto',
  'simulation.text_mode_active': 'Modo de texto activo: escriba su respuesta a continuación',
  'simulation.text_input_placeholder': 'Escriba su respuesta aquí y presione Enter...',
  'simulation.text_input_ai_speaking': '{{name}} está hablando...',
  'simulation.text_input_ai_thinking': 'La IA está pensando...',
  'simulation.text_send': 'Enviar',
  'simulation.switch_to_voice': 'Volver al modo de voz',
  'simulation.mic_live': 'En vivo',
  'simulation.mic_muted': 'Silenciado',
  'simulation.camera_live': 'Activa',
  'simulation.camera_off': 'Apagada',
  'simulation.auto_saved_long': 'Guardado automático · reanude si se desconecta',
  'simulation.auto_saved_short': 'Guardado automático',
  'simulation.attempt_progress': '{{category}} · Intento {{current}} de {{max}}',
  'simulation.rec_badge': 'GRAB',
  'simulation.init_badge': 'INIC',
  'simulation.nocam_badge': 'SIN CÁM',
  'simulation.time_left': 'Tiempo restante',
  'simulation.elapsed': 'Transcurrido',
  'simulation.stage_label': 'Etapa',
  'simulation.stage_progress': '{{current}} de {{total}} · {{name}}',
  'simulation.live_llm_trace': 'Traza LLM en Vivo',
  'simulation.inspect_trace_tooltip': 'Inspeccionar llamadas a API de LLM, prompts del sistema y estados de diálogo',
  'simulation.audio_error_desc': 'Se utilizará síntesis de voz si está disponible, o puede reintentar la reproducción a continuación.',
  'simulation.retry_audio': 'Reintentar audio',
  'simulation.buffering_audio': 'Cargando audio…',
  'simulation.persona_thinking': 'Pensando...',
  'simulation.repeat': 'Repetir',
  'simulation.repeat_persona_tooltip': 'Repetir última respuesta de {{name}}',
  'simulation.ai_voice_chip': 'Voz de IA',
  'simulation.ai_voice_tooltip': 'La voz de este personaje es generada por IA',
  'simulation.camera_off_overlay': 'Cámara apagada',
  'simulation.speaking_badge': 'Hablando',
  'simulation.you_label': 'Tú',
  'simulation.scenario_heading': 'Escenario',
  'simulation.scenario_hide_tip': 'Clic para ocultar el resumen',
  'simulation.scenario_view_tip': 'Clic para ver el resumen completo del escenario',
  'simulation.hide': 'Ocultar',
  'simulation.show': 'Mostrar',
  'simulation.your_objective': 'Tu Objetivo',
  'simulation.scenario_personas': 'Personajes del Escenario',
  'simulation.live_transcript': 'Transcripción en vivo',
  'simulation.live_badge': 'En vivo',
  'simulation.transcript_listening': 'Esperando inicio de conversación...',
  'simulation.role_learner': 'Participante',
  'simulation.role_ai_prefix': 'IA · {{role}}',
  'simulation.repeat_message_tooltip': 'Repetir este mensaje',
  'simulation.participants_single': '1 agente de IA ({{name}}) + tú',
  'simulation.participants_multiple': '{{count}} personajes de IA + tú',
  'simulation.toggle_mic_tooltip': 'Alternar micrófono',
  'simulation.toggle_camera_tooltip': 'Alternar cámara',
  'simulation.camera_on': 'Cámara encendida',
  'simulation.cam_on_short': 'Cám activa',
  'simulation.cam_off_short': 'Cám inactiva',
  'simulation.repeat_last_tooltip': 'Repetir último mensaje',
  'simulation.repeat_last': 'Repetir último',
  'simulation.transcript_tooltip': 'Ver transcripción completa de la conversación',
  'simulation.transcript': 'Transcripción',
  'simulation.end_assessment_tooltip': 'Finalizar evaluación',
  'simulation.end_assessment': 'Finalizar evaluación',
  'simulation.end_short': 'Fin',
  'simulation.end_modal_title': '¿Finalizar esta simulación?',
  'simulation.end_modal_desc': 'Su audio, video y transcripción se enviarán para calificación y comentarios. No podrá continuar este intento.',
  'simulation.end_modal_time_elapsed': 'Tiempo transcurrido',
  'simulation.end_modal_turns_recorded': 'Turnos registrados',
  'simulation.end_modal_turns_count': '{{count}} turnos',
  'simulation.end_modal_continue': 'Continuar simulación',
  'simulation.end_modal_submit': 'Finalizar y enviar',
  'simulation.turn_ended_complete_title': 'Conversación completada',
  'simulation.turn_ended_limit_title': 'Límite de turnos alcanzado',
  'simulation.turn_ended_desc': 'Revise y continúe al informe de resultados',
  'simulation.turn_ended_view_report': 'Ver informe de resultados',
  'simulation.trace_modal_title': 'Inspeccionar llamadas de API de LLM, prompts y estados de diálogo',
  'simulation.trace_modal_close': 'Cerrar',
  'simulation.dismiss_banner': 'Descartar aviso',
  'simulation.role_ai': 'IA',
  'simulation.mic_permission_help_title': 'Ayuda para permisos de micrófono',
  'simulation.switch_to_voice_title': 'Volver al modo de voz',
  'simulation.privacy_video_notice': 'Las observaciones se procesan 100% localmente en su navegador. El video original nunca se envía al servidor.',
  'simulation.live_learner_speaking': 'Hablando...',
  'simulation.ready_to_begin': 'Listo para comenzar el diálogo',
  'simulation.ready_to_begin_desc': 'Hable por su micrófono o escriba una respuesta en el cuadro de entrada rápida a continuación.',
  'simulation.replay': 'Reproducir',
  'simulation.return_to_stage': 'Volver a la etapa de simulación',
  'simulation.trace_session_attempt': 'Intento de sesión',
  'simulation.trace_target_persona': 'Persona objetivo',
  'simulation.trace_stage_progression': 'Progresión de etapa',
  'simulation.trace_language_turns': 'Idioma y turnos',
  'simulation.trace_turns_count': '{{count}} turnos',
  'simulation.trace_live_exchange_log': 'Registro en vivo de turnos ({{count}} turnos)',
  'simulation.trace_realtime_stream': 'Flujo de diálogo en tiempo real',
  'simulation.trace_no_turns': 'Aún no se procesaron turnos. Hable o escriba su saludo para iniciar el diálogo.',
  'simulation.submit_response': 'Enviar respuesta',
  'simulation.auto_submitting_in': 'Envío automático en {{seconds}}s…',
  'simulation.speak_to_continue': 'Habla para continuar o envía ahora',
  'simulation.submitting_countdown': 'Enviando en {{seconds}}s',

  // Simulation Completion & Results Generation Popup
  'simulation.eval_overlay_title': 'Analizando y preparando resultados',
  'simulation.eval_overlay_desc': 'Tu simulación ha finalizado. El motor de evaluación multidimensional de Trainova está sintetizando los turnos del diálogo, evaluando las competencias y preparando tu cuadro de mando integral...',
  'simulation.eval_mic_video_stopped': 'Captura de micrófono y video detenida',
  'simulation.eval_mic_stopped': 'Captura de micrófono detenida',
  'simulation.eval_transcript_captured': 'Transcripción de la sesión capturada ({{count}} turnos)',
  'simulation.eval_generating_scorecard': 'Generando evaluación por rúbrica y cuadro de mando conductual...',
  'simulation.eval_stuck_desc': 'Esto está tardando más de lo habitual. Puedes seguir esperando aquí, o abrir el intento y leer la tarjeta de puntuación una vez que finalice.',
  'simulation.eval_open_attempt_btn': 'Abrir mi intento →',

  // Simulation Completion Banner & Dialogue End Modals
  'simulation.turns_completed_summary': 'Turnos de simulación completados ({{count}} turnos).',
  'simulation.ready_for_debrief': 'Listo para el informe de evaluación.',
  'simulation.turn_ended_limit_desc': 'Has alcanzado el número máximo permitido de turnos de conversación ({{current}} de {{max}} turnos) para esta simulación.',
  'simulation.turn_ended_concluded_desc': 'Tu interlocutor ha concluido la conversación ({{count}} turnos registrados).',

  // Room Initialization Screen & Readiness Stepper
  'simulation.initializing_room_title': 'Inicializando sala de simulación...',
  'simulation.init_slow_desc': 'Conectar con el motor de rol de IA está tardando más de lo habitual. Puedes esperar un momento o intentar reconectar.',
  'simulation.init_loading_desc': 'Cargando resumen del escenario, directivas del personaje e iniciando diálogo.',
  'simulation.init_briefing_loaded': 'Sesión informativa del escenario y directivas del personaje',
  'simulation.init_dialogue_connected': 'Motor de diálogo conectado',
  'simulation.init_mic_ready': 'Micrófono listo para interrupción',
  'simulation.init_audio_loaded': 'Recursos de audio necesarios cargados y decodificados',
  'simulation.init_ready': 'Listo',
  'simulation.init_waiting': 'Esperando',
  'simulation.mic_blocked_init_title': 'El acceso al micrófono está bloqueado',
  'simulation.mic_blocked_init_desc': 'Permite el acceso al micrófono en la barra de direcciones de tu navegador y luego vuelve a intentarlo. Si no aparece ningún aviso, es posible que este navegador o conexión no admita la captura de micrófono; la sala aún puede abrirse con respuestas escritas.',
  'simulation.requesting_access': 'Solicitando acceso…',
  'simulation.retry_mic_init': 'Reintentar micrófono',
  'simulation.mic_checking_desc': 'Permite el acceso al micrófono si tu navegador lo solicita; podrás hablar en cuanto se abra la sala.',
  'simulation.reconnect_room': 'Reconectar sala',
  'simulation.back_to_briefing': 'Volver a la sesión informativa',
  'simulation.exit_to_briefing': 'Salir a la sesión informativa',
  'simulation.unable_to_start': 'No se pudo iniciar la simulación',

  // Role & Mood Lookups
  'role.customer': 'Cliente',
  'role.client': 'Cliente',
  'role.manager': 'Gerente',
  'role.colleague': 'Colega',
  'role.learner': 'Participante',
  'mood.irritated_polite': 'Ligeramente irritado pero cortés',
  'mood.frustrated': 'Frustrado',
  'mood.satisfied': 'Satisfecho',
  'mood.neutral': 'Neutral',
  'mood.anxious': 'Ansioso',
  'mood.demanding': 'Exigente',

  // Evaluation Scorecard & Results
  'scorecard.title': 'Tarjeta de Evaluación del Desempeño',
  'scorecard.overall_score': 'Puntuación General de Rendimiento',
  'scorecard.passing_score': 'Estándar de Aprobación: {{score}}%',
  'scorecard.status_passed': 'Aprobado',
  'scorecard.status_failed': 'Requiere Mejora',
  'scorecard.status_in_progress': 'Evaluando',
  'scorecard.competencies_title': 'Competencias Principales Evaluadas',
  'scorecard.key_strengths': 'Principales Fortalezas Demostradas',
  'scorecard.areas_for_growth': 'Oportunidades de Crecimiento',
  'scorecard.actionable_recommendations': 'Recomendaciones Prácticas de Coaching',
  'scorecard.evidence_quotes': 'Citas Textuales de la Transcripción',
  'scorecard.replay_recording': 'Grabación y Reproducción de la Sesión',
  'scorecard.download_report': 'Descargar Informe en PDF',
  'scorecard.retry_btn': 'Reintentar Simulación',
  'scorecard.back_dashboard': 'Volver al Panel Principal',
  'scorecard.retake_simulation': 'Reintentar simulación',
  'scorecard.reevaluate_openai': 'Reevaluar con OpenAI',
  'scorecard.evaluating_action': 'Evaluando...',
  'scorecard.practice_similar': 'Practicar similar',
  'scorecard.download_json': 'Descargar informe JSON',
  'scorecard.inspect_prompts': 'Inspeccionar prompts de LLM',
  'scorecard.attempt_counter': 'Intento {{current}} de {{max}}',
  'scorecard.target_passing_score': 'Puntuación mínima requerida: {{score}}%',
  'scorecard.role_label': 'Rol:',
  'scorecard.persona_label': 'Personaje:',
  'scorecard.scorecard_title_suffix': 'Tarjeta de puntuación',
  'scorecard.badge_passed': 'Aprobado',
  'scorecard.badge_needs_review': 'Requiere revisión',
  'scorecard.badge_completed': 'Completado',
  'scorecard.badge_ai_eval': 'Evaluación con IA',
  'scorecard.all_attempts_btn': '‹ Todos los intentos',
  'scorecard.analyzing_attempt': 'Analizando rendimiento del intento...',
  'scorecard.evaluating_subtext': 'Evaluando el habla, las rúbricas de conversación y generando retroalimentación de coaching.',
  'scorecard.in_progress_title': 'El intento está en curso',
  'scorecard.in_progress_desc': 'Este intento aún no ha sido enviado para evaluación. Puede reanudar y finalizar la sesión, o enviarla ahora para generar su informe de evaluación.',
  'scorecard.resume_simulation': 'Reanudar simulación',
  'scorecard.end_and_submit': 'Finalizar y enviar para evaluación',
  'scorecard.submitting_evaluating': 'Enviando y evaluando...',
  'scorecard.my_attempts': 'Mis intentos',
  'scorecard.assessment_completed_title': 'Evaluación completada',
  'scorecard.session_recording_title': 'Grabación de su sesión',
  'scorecard.dashboard_btn': 'Panel principal',
  'scorecard.overall_score_label': 'Puntuación general',
  'scorecard.below_target': 'Por debajo del objetivo',
  'scorecard.target_achieved': 'Objetivo alcanzado',
  'scorecard.pass_mark_desc': 'Puntaje de aprobación {{score}}%. Revise los comentarios de coaching a continuación e inicie su siguiente intento para alcanzar la preparación.',
  'scorecard.readiness_label': 'PREPARACIÓN',
  'scorecard.target_label': 'Objetivo',
  'scorecard.time_taken_label': 'TIEMPO EMPLEADO',
  'scorecard.of_time': 'de {{time}}',
  'scorecard.stages_completed_label': 'ETAPAS COMPLETADAS',
  'scorecard.stages_of': '{{current}} de {{total}}',
  'scorecard.all_stages_reached': 'Todas las etapas de conversación alcanzadas',
  'scorecard.evaluated_label': 'EVALUADO',
  'scorecard.overall_feedback_title': 'Comentarios generales',
  'scorecard.ai_summary_reviewed': 'Resumen de IA · revisado por entrenador',
  'scorecard.overall_feedback_empty': 'Los comentarios generales aparecerán aquí una vez completada la evaluación.',
  'scorecard.based_on_rubric': 'Basado en la grabación, la transcripción y la rúbrica de su organización.',
  'scorecard.top_strength_tag': 'MAYOR FORTALEZA',
  'scorecard.biggest_gap_tag': 'MAYOR OPORTUNIDAD',
  'scorecard.delivery_tag': 'ENTREGA',
  'scorecard.speaking_pace_measured': 'Ritmo de habla medido',
  'scorecard.metric_breakdown_empty': 'El desglose de métricas aparecerá después de la evaluación.',
  'scorecard.competency_breakdown_title': 'Desglose de competencias',
  'scorecard.scored_against_rubric': 'Calificado según la rúbrica de su organización',
  'scorecard.legend_strong': 'Excelente (4.0+)',
  'scorecard.legend_ontrack': 'En buen camino (3.0 - 3.9)',
  'scorecard.legend_needswork': 'Requiere mejora (menos de 3.0)',
  'scorecard.no_competencies_evaluated': 'No se evaluaron rúbricas de competencia para esta sesión.',
  'scorecard.weight_pct': 'Ponderación {{pct}}%',
  'scorecard.score_calc_traceability': 'Cálculo de puntuación y trazabilidad de ponderación',
  'scorecard.formula_label': 'Fórmula:',
  'scorecard.table_competency': 'Competencia',
  'scorecard.table_raw_score': 'Puntaje bruto',
  'scorecard.table_weight': 'Ponderación',
  'scorecard.table_contribution': 'Contribución',
  'scorecard.total_calc_score': 'Puntuación total calculada:',
  'scorecard.pass_threshold': 'Umbral de aprobación: {{score}}%',
  'scorecard.evidence_traceability_prefix': 'Trazabilidad de evidencia:',
  'scorecard.criterion_not_met': 'Criterio no cumplido durante la conversación.',
  'scorecard.improvement_tips_title': 'Consejos de mejora',
  'scorecard.most_impact_first': 'Mayor impacto primero',
  'scorecard.improvement_tips_empty': 'Los consejos de mejora aparecerán aquí una vez completada la evaluación con IA.',
  'scorecard.actionable_recommendation_label': 'Recomendación práctica:',
  'scorecard.camera_analysis_title': 'Análisis de video de cámara',
  'scorecard.audio_only_scenario': 'Escenario solo de audio',
  'scorecard.audio_only_desc': 'Esta simulación está configurada como una evaluación solo de audio. No se solicitó ni se grabó video para este escenario.',
  'scorecard.assessment_mode_voice': 'Modo de evaluación: Solo voz',
  'scorecard.scoring_focus_empathy': 'Enfoque de calificación: Empatía, tono y comunicación',
  'scorecard.privacy_no_camera': 'Privacidad: No se grabó video',
  'scorecard.not_recorded': 'No grabado',
  'scorecard.video_processing': 'Procesamiento de video',
  'scorecard.video_processing_sub': 'El análisis de visión artificial se está ejecutando en segundo plano.',
  'scorecard.partial_analysis': 'Análisis parcial',
  'scorecard.analysis_completed': 'Análisis completado',
  'scorecard.cv_observations_sub': "Observaciones locales de visión artificial derivadas de la cámara del participante.",
  'scorecard.face_visible': 'Visibilidad del rostro',
  'scorecard.continuous_presence': 'Presencia continua en el encuadre de la cámara',
  'scorecard.conversation_quality_title': 'Calidad de la conversación',
  'scorecard.how_customer_felt_sub': 'Cómo se sintió el cliente durante la llamada',
  'scorecard.sentiment_over_call': 'Sentimiento del cliente durante la llamada',
  'scorecard.sentiment_satisfied': 'Satisfecho',
  'scorecard.sentiment_neutral': 'Neutral',
  'scorecard.sentiment_upset': 'Molesto',
  'scorecard.start_time': 'Inicio',
  'scorecard.end_time': 'Fin',
  'scorecard.sentiment_data_empty': 'La cronología de sentimiento aparecerá una vez evaluada la conversación.',
  'scorecard.required_steps_title': 'Pasos requeridos (cumplimiento)',
  'scorecard.completed_of_total': '{{done}} de {{total}} completados',
  'scorecard.compliance_steps_empty': 'No se definieron pasos de cumplimiento para este escenario.',
  'scorecard.step_done': 'Hecho',
  'scorecard.step_missed': 'Omitido',
  'scorecard.scroll_to_view_steps': 'Desplácese para ver los {{count}} pasos',
  'scorecard.coach_comments_title': 'Comentarios del entrenador',
  'scorecard.comments_count_single': '1 comentario',
  'scorecard.comments_count_plural': '{{count}} comentarios',
  'scorecard.reply_placeholder': 'Responder a las notas del entrenador...',
  'scorecard.reply_btn': 'Responder',
  'scorecard.evaluation_unavailable': 'Resultados de evaluación no disponibles',
  'scorecard.retry_fetch': 'Reintentar',

  // Video & Recording Replay
  'video.session_recording': 'Grabación de la Sesión de Evaluación',
  'video.learner_cam': 'Video del Participante',
  'video.persona_cam': 'Personaje de IA',
  'video.play': 'Reproducir',
  'video.pause': 'Pausar',
  'video.restart': 'Reiniciar',
  'video.playback_speed': 'Velocidad',
  'video.recording_unavailable': 'La grabación de la sesión se está procesando o no está disponible.',
  'video.recording_audio_only': 'Sesión Solo de Audio',

  // Tenant Admin & Settings
  'admin.languages_title': 'Idiomas y Configuraciones Regionales',
  'admin.languages_subtitle': 'Configura los idiomas habilitados, el idioma predeterminado y el acceso para tu organización.',
  'admin.supported_languages': 'Idiomas Habilitados para la Organización',
  'admin.default_language': 'Idioma Predeterminado de la Organización',
  'admin.fallback_language': 'Idioma de Respaldo',
  'admin.onboarding_language': 'Idioma Predeterminado de Bienvenida',
  'admin.allow_user_selection': 'Permitir a los usuarios cambiar el idioma de visualización',
  'admin.allow_user_selection_help': 'Si está activado, los usuarios verán el selector de idioma en su barra de navegación.',
  'admin.test_preview_title': 'Prueba del Proveedor de Traducción y Vista Previa',
  'admin.test_input_label': 'Texto de Muestra para Traducir',
  'admin.test_target_label': 'Idioma Destino',
  'admin.test_run_btn': 'Probar API de Traducción',
  'admin.test_result_label': 'Resultado de la Traducción',
  'admin.save_settings': 'Guardar Configuración de Idiomas',
  'admin.saved_success': 'Configuración de idiomas guardada con éxito.',
  'admin.provider_google': 'Proveedor de Traducción Google Cloud (Activo)',
  'admin.provider_cached': 'En Caché en el Registro de Traducciones Multi-Inquilino',
  'admin.console_title': 'Consola de Administración de Trainova AI',

  // Navigation Extras
  'nav.group_workspace': 'Espacio de Trabajo',
  'nav.group_administration': 'Administración',
  'nav.group_account': 'Cuenta y Soporte',
  'nav.learners_users': 'Estudiantes y Usuarios',
  'nav.organizations': 'Organizaciones',
  'nav.rubrics': 'Rúbricas de Evaluación',
  'nav.llm_logs': 'Registros de Auditoría LLM',
  'nav.audit_trail': 'Pistas de Auditoría de Seguridad',

  // Page Titles
  'dashboard.assigned_studio': 'Simulaciones Asignadas y Estudio de Práctica',
  'dashboard.search_placeholder': 'Buscar escenarios, personajes...',
  'attempts.title_admin': 'Intentos de Simulación y Registro de Desempeño',
  'attempts.title_learner': 'Mis Intentos de Simulación e Historial',
  'attempts.history_title': 'Historial de Intentos del Escenario',
  'scenarios.studio_title': 'Estudio de Escenarios y Simulación',
  'users.directory_title': 'Miembros de la Organización y Directorio',
  'tenants.title': 'Organizaciones de la Plataforma e Inquilinos',
  'audit.title': 'Pistas de Auditoría y Gobernanza Empresarial',
  'llm_logs.title': 'Registros del Motor LLM y Auditoría de Inferencia',
  'reports.title': 'Informes Empresariales y Analítica de Cohortes',
  'analytics.title': 'Analítica e Inteligencia de Práctica',

  // Breadcrumbs
  'breadcrumb.home': 'Inicio',
  'breadcrumb.dashboard': 'Panel Principal',
  'breadcrumb.admin': 'Administración',
  'breadcrumb.learner_portal': 'Portal del Estudiante',
  'breadcrumb.administration_console': 'Consola de Administración',
  'breadcrumb.simulation_attempts': 'Intentos de Simulación',
  'breadcrumb.my_simulation_attempts': 'Mis Intentos de Simulación',
  'breadcrumb.my_attempts': 'Mis Intentos',
  'breadcrumb.attempt_history': 'Historial de Intentos',
  'breadcrumb.assigned_simulations': 'Simulaciones Asignadas',
  'breadcrumb.scenarios_studio': 'Estudio de Escenarios',
  'breadcrumb.scenarios': 'Escenarios',
  'breadcrumb.scenario_details': 'Detalles del Escenario',
  'breadcrumb.create_scenario': 'Crear Escenario',
  'breadcrumb.edit_scenario': 'Editar Escenario',
  'breadcrumb.user_directory': 'Directorio de Usuarios',
  'breadcrumb.learners_users': 'Estudiantes y Usuarios',
  'breadcrumb.client_organizations': 'Organizaciones Clientes',
  'breadcrumb.org_details': 'Detalles de la Organización',
  'breadcrumb.evaluation_rubrics': 'Rúbricas de Evaluación',
  'breadcrumb.evaluation_config': 'Configuración de Evaluación',
  'breadcrumb.evaluation_studio': 'Estudio de Evaluación',
  'breadcrumb.reports_analytics': 'Informes y Analítica',
  'breadcrumb.reports': 'Informes',
  'breadcrumb.analytics': 'Analítica',
  'breadcrumb.audit_log': 'Registro de Auditoría',
  'breadcrumb.audit_trail': 'Pistas de Auditoría de Seguridad',
  'breadcrumb.llm_audit_trail': 'Pista de Auditoría LLM',
  'breadcrumb.llm_logs': 'Registros LLM',
  'breadcrumb.tenant_settings': 'Configuración de Organización',
  'breadcrumb.notifications': 'Configuración de Notificaciones',
  'breadcrumb.custom_fields': 'Campos de Usuario Personalizados',
  'breadcrumb.packages': 'Gestión de Paquetes',

  // Table Headers & Controls
  'table.simulation': 'Simulación',
  'table.category': 'Categoría',
  'table.status': 'Estado',
  'table.time_limit': 'Límite de Tiempo',
  'table.attempts_left': 'Intentos Restantes',
  'table.progress': 'Progreso',
  'table.actions': 'Acciones',
  'table.member': 'Miembro',
  'table.emp_id': 'ID Empleado',
  'table.designation': 'Cargo',
  'table.reporting_manager': 'Responsable Directo',
  'table.team': 'Equipo',
  'table.region': 'Región',
  'table.role': 'Rol',
  'table.attempt_num': 'Intento #',
  'table.started': 'Iniciado',
  'table.duration': 'Duración',
  'table.turns': 'Turnos',
  'table.score': 'Puntuación',
  'table.ai_persona': 'Personaje IA',
  'table.difficulty': 'Dificultad',
  'table.scenario': 'Escenario',
  'table.organization': 'Organización',
  'table.slug': 'Identificador',
  'table.users': 'Usuarios',
  'table.scenarios': 'Escenarios',
  'table.attempts': 'Intentos',
  'table.created': 'Creado',
  'table.timestamp': 'Fecha y Hora',
  'table.action': 'Acción',
  'table.actor': 'Autor',
  'table.target': 'Objetivo',
  'table.origin_ip': 'Origen / IP',
  'table.payload': 'Carga Útil',
  'table.no_records': 'No se encontraron registros',
  'table.no_attempts': 'No se encontraron intentos',
  'table.no_attempts_desc': 'Aún no se han registrado intentos para este escenario.',
  'table.no_users': 'No se encontraron usuarios coincidentes.',
  'table.no_orgs': 'No se encontraron organizaciones',
  'table.no_orgs_desc': 'Intenta modificar tus términos de búsqueda o filtros.',
  'table.view_details': 'Ver Detalles',
  'table.filter_all': 'Todos',
  'table.filter_not_started': 'No Iniciados',
  'table.filter_in_progress': 'En Progreso',
  'table.filter_completed': 'Completados',
  'table.filter_all_statuses': 'Todos los Estados',
  'table.filter_all_categories': 'Todas las Categorías',
  'table.filter_all_difficulties': 'Todas las Dificultades',
  'table.published': 'Publicado',
  'table.draft': 'Borrador',
  'table.archived': 'Archivado',
  'table.beginner': 'Principiante',
  'table.intermediate': 'Intermedio',
  'table.advanced': 'Avanzado',
  'table.sort_latest': 'Ordenar: Más reciente',
  'table.sort_title': 'Ordenar: Título',
  'table.sort_duration': 'Ordenar: Duración',

  // Badges
  'badge.enterprise_control_plane': 'Plano de Control Empresarial',
  'badge.roleplay_hub': 'Centro de Simulación',
  'badge.practice_ledger': 'Registro de Prácticas',
  'badge.admin_practice_ledger': 'Registro de Prácticas Administrativo',
  'badge.simulation_authoring': 'Creación de Simulaciones',
  'badge.access_governance': 'Acceso y Gobernanza',
  'badge.multi_tenant_master': 'Maestro Multi-Inquilino',
  'badge.evaluation_governance': 'Gobernanza de Evaluación',
  'badge.executive_intelligence': 'Inteligencia Ejecutiva',
  'badge.security_compliance': 'Seguridad y Cumplimiento',
  'badge.ai_observability': 'Observabilidad IA',

  // Common UI Actions & Statuses
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.loading': 'Cargando...',
  'common.loading_records': 'Cargando registros del historial…',
  'common.submitting': 'Enviando...',
  'common.error': 'Ocurrió un error inesperado. Por favor, inténtalo de nuevo.',
  'common.retry': 'Reintentar',
  'common.success': 'Éxito',
  'common.status': 'Estado',
  'common.active': 'Activo',
  'common.disabled': 'Desactivado',
  'common.optional': 'Opcional',
  'common.required': 'Obligatorio',
  'common.offline_notice': 'Actualmente estás sin conexión. Mostrando datos en caché y recursos locales.',
  'common.learn_more': 'Saber Más',
  'common.back': 'Atrás',

  // Hero Descriptions
  'desc.select_scenario': 'Seleccione un escenario de evaluación para comenzar o continuar su simulación conversacional',
  'desc.attempts_admin': 'Supervise simulaciones de alumnos entre organizaciones, inspeccione tarjetas de puntuación y audite resultados.',
  'desc.attempts_learner': 'Rastree sus sesiones de simulación, reanude escenarios activos y revise tarjetas de puntuación anteriores.',
  'desc.scenarios': 'Cree, pruebe y publique simulaciones de IA conversacional, personas de clientes y rúbricas de evaluación.',
  'desc.tenants': 'Gestión centralizada de organizaciones cliente, aprovisionamiento de inquilinos y gobernanza de la plataforma.',
  'desc.users': 'Administre cuentas de alumnos, asigne permisos de instructores y administradores, y supervise cohortes.',
  'desc.audit': 'Inspeccione eventos inmutables de cumplimiento, modificaciones administrativas e historial de autenticación.',
  'desc.llm_audit': 'Audite prompts de LLM, consumo de tokens de entrada/salida, latencias de modelos, costos y cargas útiles.',
  'desc.reports': 'Revise tasas de aprobación de organizaciones, barras de referencia de competencias y métricas de alumnos.',
  'desc.analytics': 'Métricas de finalización de simulaciones en tiempo real, tasas de aprobación y rendimiento multi-inquilino.',
  'desc.admin_dashboard': 'Gobernanza global del sistema, administración de inquilinos, métricas de capacitación y estudio de simulación de IA.',
  'desc.llm_config': 'Configure modelos de LLM de diálogo, motores de puntuación, modelos de voz STT/TTS y claves de API cifradas.',
  'desc.udf_settings': 'Configure campos de metadatos de alumnos (región, centro de costos, BU), reglas de validación CSV y asignaciones de API.',
  'desc.eval_config': 'Configure rúbricas de evaluación, prompts de puntuación, calibración de conjunto dorado y ciclos de publicación.',

  // Dashboard Stats & Cards
  'dashboard.stats.total_simulations': 'Simulaciones Totales',
  'dashboard.stats.in_progress': 'En Progreso',
  'dashboard.stats.completed': 'Completadas',
  'dashboard.stats.not_started': 'No Iniciadas',
  'dashboard.facts.time_limit': 'Límite de Tiempo',
  'dashboard.facts.mins': 'min',
  'dashboard.facts.attempts': 'Intentos',
  'dashboard.facts.pass_benchmark': 'Puntuación Mínima',
  'dashboard.facts.benchmark': 'Punto de Referencia',
  'dashboard.facts.attempt_progress': 'Progreso del intento',
  'dashboard.actions.briefing_and_start': 'Instrucciones y Comenzar →',
  'dashboard.actions.resume_attempt': 'Reanudar Intento →',
  'dashboard.actions.view_scorecard': 'Ver Tarjeta de Puntuación',
  'dashboard.actions.max_attempts_reached': 'Intentos Máximos Alcanzados',
  'dashboard.actions.available_soon': 'Disponible Pronto',
  'dashboard.actions.simulation_closed': 'Simulación Cerrada',
  'dashboard.actions.briefing': 'Instrucciones →',
  'dashboard.actions.resume': 'Reanudar',
  'dashboard.actions.scorecard': 'Puntuación',

  // Status Labels
  'status.not_started': 'No Iniciado',
  'status.in_progress': 'En Progreso',
  'status.completed': 'Completado',
  'status.assigned': '★ Asignado',
  'status.ready_to_practice': 'Listo para practicar',
  'status.passed': 'Aprobado',
  'status.not_passed': 'No aprobado',
  'status.paused': 'Pausado',
  'status.evaluated': 'Evaluado',
  'status.expired': 'Expirado',
  'status.abandoned': 'Abandonado',
  'status.unknown': 'Desconocido',

  // Attempts Stats & Actions
  'attempts.stats.total_attempts': 'Intentos Totales',
  'attempts.stats.expired_inactive': 'Expirado / Inactivo',
  'attempts.loading_title': 'Cargando Intentos de Práctica...',
  'attempts.loading_desc': 'Recuperando sesiones de simulación, resultados de intentos y registros históricos de práctica.',
  'attempts.no_attempts_title': 'No hay intentos que coincidan con los criterios',
  'attempts.no_attempts_filter_hint': 'Intenta cambiar o borrar tu consulta de búsqueda y filtros de estado.',
  'attempts.no_attempts_empty_hint': 'Aún no has comenzado ningún intento de simulación. Elige un escenario del catálogo para comenzar a practicar.',
  'attempts.start_scenario_cta': 'Iniciar un Escenario',
  'attempts.pagination_label': 'intentos',
  'attempts.tabs.all': 'Todos los Intentos',
  'attempts.admin_ledger_badge': '🛡️ Libro de Intentos del Administrador',
  'attempts.all_organizations': '🏢 Todas las Organizaciones (Global)',
  'attempts.search_organization_placeholder': 'Buscar organización por nombre o slug…',
  'attempts.no_organizations_match': 'Ninguna organización coincide con "{{query}}"',
  'attempts.view_scope_label': 'Ámbito de visualización:',
  'attempts.all_learners': '👥 Todos los Alumnos',
  'attempts.my_own_attempts': '👤 Mis Propios Intentos',
  'attempts.search_learner_placeholder': 'Buscar alumno por nombre o correo…',
  'attempts.learners_in_scope': 'Alumnos en el Ámbito ({{count}})',
  'attempts.no_learners_match': 'Ningún alumno coincide con "{{query}}"',
  'attempts.loading_attempts': 'Cargando intentos de simulación...',
  'attempts.showing_count': 'Mostrando {{count}} intento de simulación',
  'attempts.showing_count_plural': 'Mostrando {{count}} intentos de simulación',
  'attempts.search_placeholder': 'Buscar escenarios...',
  'attempts.meta.attempt': 'Intento',
  'attempts.meta.difficulty': 'Dificultad',
  'attempts.meta.date': 'Fecha',
  'attempts.meta.evaluation': 'Evaluación',
  'attempts.meta.not_started': 'No iniciado',
  'attempts.view_scorecard': 'Ver Tarjeta de Puntuación →',
  'attempts.view_attempt': 'Ver Intento →',
  'attempts.all_attempts_link': 'Todos los Intentos',
  'attempts.progress.turns': 'Progreso de Turnos',
  'attempts.progress.turns_unit': 'turnos',
  'attempts.progress.elapsed_time': 'Tiempo Transcurrido',
  'attempts.action.resuming': 'Reanudando...',
  'attempts.action.resume_simulation': 'Reanudar Simulación',
  'attempts.err_resume_failed': 'Error al reanudar el intento',
  'attempts.action.starting': 'Iniciando...',
  'attempts.action.retry_attempt': 'Reintentar Intento',
  'attempts.action.quota_exhausted': 'Cuota Agotada',
  'attempts.action.attempts_left': 'restantes',
  'attempts.action.attempts_remaining': '{{count}} intentos restantes',
  'attempts.action.quota_reached': 'Cuota de intentos alcanzada',
  'attempts.action.retry_simulation': 'Reintentar Simulación',
  'attempts.meta.quota': 'Cuota',
  'attempts.meta.of': 'de',
  'attempts.history_title_default': 'Historial de Intentos de Escenario',
  'attempts.history_subtitle': 'Mostrando todos los intentos registrados y la progresión de este escenario.',
  'attempts.history_quota_used': '{{used}} / {{max}} usados (quedan {{remaining}})',

  // Attempts Strip (Results & Key Moments)
  'attempts.strip.your_attempts': 'SUS INTENTOS',
  'attempts.strip.used_of_total': '{{used}} de {{total}} usados',
  'attempts.strip.best_counts': 'La mejor puntuación cuenta para el resultado',
  'attempts.strip.attempt_n': 'INTENTO {{n}}',
  'attempts.strip.best': 'MEJOR',
  'attempts.strip.viewing': 'VIENDO',
  'attempts.strip.available': 'Disponible',
  'attempts.strip.passed': '✓ Aprobado',
  'attempts.strip.needs_review': '✕ Necesita Revisión',
  'attempts.strip.view_details': 'Ver detalles →',
  'attempts.strip.take_attempt': 'Iniciar intento',

  // Pagination
  'pagination.showing': 'Mostrando {{start}}–{{end}} de {{total}} {{items}}',
  'pagination.per_page': 'Por página:',
  'pagination.previous': '‹ Anterior',
  'pagination.next': 'Siguiente ›',
  'pagination.page_aria': 'Página {{page}}',
  'pagination.prev_aria': 'Página anterior',
  'pagination.next_aria': 'Página siguiente',
  'pagination.select_per_page_aria': 'Seleccionar elementos por página',
  'pagination.nav_aria': 'Paginación',

  // Difficulty & Category
  'difficulty.beginner': 'Principiante',
  'difficulty.intermediate': 'Intermedio',
  'difficulty.advanced': 'Avanzado',
  'difficulty.standard': 'Estándar',
  'category.customer_service': 'Servicio al Cliente',
  'category.sales': 'Ventas',
  'category.compliance': 'Cumplimiento',
  'category.de_escalation': 'Desescalada',
  'category.coaching': 'Entrenamiento',
  'category.general_scenario': 'Escenario General',

  // Common Labels
  'common.organization_label': 'Organización:',
  'common.attempts': 'intentos',
  'nav.explore_scenarios': 'Explorar Escenarios',
  'nav.learner_portal': 'Portal del Alumno',

  // Admin Overview KPI Stats
  'admin.stats.total_organizations': 'Organizaciones Cliente Totales',
  'admin.stats.active_subscriptions': 'suscripciones empresariales activas',
  'admin.stats.active_workspaces': 'Espacios de Trabajo Activos',
  'admin.stats.live_proctoring': 'En vivo y con supervisión habilitada',
  'admin.stats.org_members': 'Miembros de la Organización',
  'admin.stats.active_seats': 'asientos de alumnos activos',
  'admin.stats.active_accounts': 'Cuentas Activas',
  'admin.stats.compliant_sso': 'Conforme y verificado por SSO',
  'admin.stats.published_cases': 'Casos de Simulación Publicados',
  'admin.stats.total_authored_cases': 'casos creados en total',
  'admin.stats.ai_health': 'Estado del Motor de IA',
  'admin.stats.operational_100': '100% Operativo',
  'admin.stats.models_online': 'Modelos de diálogo y rúbricas en línea',

  // Admin Navigation Sections & Cards
  'admin.nav_section.org_governance': 'Gobernanza de Organización y Acceso',
  'admin.nav_section.training_analytics': 'Análisis e Informes de Capacitación',
  'admin.nav_section.ai_studio': 'Estudio de Rúbricas y Simulación de IA',
  'admin.nav_section.customization': 'Personalización y Configuración',
  'admin.nav.org_management': 'Gestión de Organizaciones',
  'admin.nav.org_management_desc': 'Aprovisione y configure inquilinos cliente, directrices de marca, dominios y límites globales.',
  'admin.nav.user_management': 'Gestión de Usuarios y Roles',
  'admin.nav.user_management_desc': 'Administre cuentas de alumnos, asigne permisos de instructores y supervise cohortes.',
  'admin.nav.security_audit': 'Registros de Seguridad y Auditoría',
  'admin.nav.security_audit_desc': 'Inspeccione eventos inmutables de cumplimiento, mutaciones administrativas e historial de autenticación.',
  'admin.nav.llm_audit': 'Pista de Auditoría de Tokens y Ejecución de LLM',
  'admin.nav.llm_audit_desc': 'Audite prompts de LLM, consumo de tokens, latencias de modelos, costos y cargas útiles por intento y escenario.',
  'admin.nav.subscription_packages': 'Paquetes de Suscripción y Pedidos',
  'admin.nav.subscription_packages_desc': 'Configure paquetes SaaS, cuotas de créditos, reglas de acumulación y apruebe pedidos adicionales.',
  'admin.nav.billing': 'Suscripción, Créditos y Complementos',
  'admin.nav.billing_desc': 'Rastree saldos de créditos de creación de simulaciones, estado acumulado y solicite paquetes complementarios o pases de voz.',
  'admin.nav.training_analytics': 'Análisis de Capacitación Empresarial',
  'admin.nav.training_analytics_desc': 'Métricas de finalización en tiempo real, tasas de aprobación de competencias y rendimiento multi-inquilino.',
  'admin.nav.reports': 'Informes de Simulación y Competencias',
  'admin.nav.reports_desc': 'Revise tasas de aprobación de organizaciones, barras de referencia de competencias, métricas de alumnos y descargas CSV/JSON.',
  'admin.nav.scenario_studio': 'Estudio de Casos y Escenarios',
  'admin.nav.scenario_studio_desc': 'Cree, edite, pruebe y publique casos de simulación, personas de clientes y rúbricas de competencias.',
  'admin.nav.evaluation_studio': 'Estudio de Evaluación de IA',
  'admin.nav.evaluation_studio_desc': 'Configure rúbricas de evaluación, prompts de puntuación, calibración y ciclos de publicación.',
  'admin.nav.llm_vault': 'Bóveda de Claves LLM y Proveedor de IA',
  'admin.nav.llm_vault_desc': 'Configure LLMs de diálogo, motores de puntuación, modelos de voz STT/TTS y claves de API cifradas.',
  'admin.nav.udf': 'Campos Personalizados del Alumno (UDF) y Mapeo',
  'admin.nav.udf_desc': 'Configure campos de metadatos de alumnos (región, centro de costos, BU), reglas de validación CSV y asignaciones de API.',
  'admin.nav.notifications': 'Configuración de Correo Electrónico y Notificaciones',

  // Reports Filters
  'reports.filters': 'Filtros',
  'reports.filter_simulation': 'Simulación:',
  'reports.select_simulation': 'Seleccionar Simulación…',
  'reports.search_sim_placeholder': 'Buscar título de simulación, categoría, ID...',
  'reports.no_sims_found': 'No se encontraron simulaciones coincidentes',
  'reports.filter_organization': 'Organización:',
  'reports.all_organizations': 'Todas las Organizaciones',
  'reports.search_org_placeholder': 'Buscar nombre de organización, ID, slug...',
  'reports.all_orgs_cross_tenant': '🌐 Todas las Organizaciones (Multi-Inquilino)',
  'reports.no_orgs_found': 'No se encontraron organizaciones coincidentes',
  'reports.filter_team': 'Equipo:',
  'reports.filter_designation': 'Puesto:',
  'reports.filter_region': 'Región:',
  'reports.filter_result': 'Resultado:',
  'reports.all_results': 'Todos los Resultados',
  'reports.clear_filters': 'Limpiar',

  // Scenario Buttons & Details
  'scenarios.back_to_scenarios': '← Volver a Escenarios',
  'scenarios.assign_learners': 'Asignar Alumnos',
  'scenarios.organization_access': 'Acceso de Organización',
  'scenarios.duplicate': 'Duplicar',
  'scenarios.llm_prompts': 'Prompts de Evaluación LLM',
  'scenarios.edit_scenario': 'Editar Escenario',
  'scenarios.learners_assigned': 'Alumnos Asignados',
  'scenarios.create_scenario': 'Crear Escenario',
  'scenarios.category': 'Categoría:',
  'scenarios.difficulty': 'Dificultad:',
  'scenarios.difficulty_label': 'Dificultad',
  'scenarios.revert_draft': 'Volver a Borrador',
  'scenarios.publish_scenario': 'Publicar Escenario',
  'scenarios.publish_and_assign': '🚀 Publicar y Asignar',
  'scenarios.archive': 'Archivar',
  'scenarios.start_simulation': 'Iniciar Simulación',
  'scenarios.loading_dossier': 'Cargando expediente del escenario…',
  'scenarios.not_found': 'Escenario no encontrado',
  'scenarios.download_template': 'Descargar Plantilla',
  'scenarios.import_json': 'Importar JSON',
  'scenarios.back_to_simulations': 'Volver a simulaciones',
  'scenarios.your_role': 'Tu Rol',
  'briefing.enter_room': 'Entrar a la Sala de Simulación →',
  'briefing.launching': 'Iniciando Simulación…',
  'briefing.resuming': 'Reanudando Simulación…',
  'briefing.loading': 'Cargando expediente de instrucciones del escenario…',
  'briefing.error_title': 'No se pudo cargar el escenario',
  'briefing.back_to_dashboard': '← Volver al Panel',
  'briefing.default_role': 'Representante de Atención al Cliente',
  'briefing.background_mission_title': 'Contexto del Escenario y Misión del Estudiante',
  'briefing.key_mission_label': 'Misión Clave',
  'briefing.default_mission': 'Desescalar al cliente, aclarar la solicitud subyacente y resolver la consulta cumpliendo los estándares de cumplimiento.',
  'briefing.persona_dossier_title': 'Expediente del Perfil del Cliente',
  'briefing.personas_dossier_title_plural': 'Expediente de Personajes del Escenario ({{count}} Participantes de IA)',
  'briefing.persona_number': 'Personaje #{{n}}',
  'briefing.persona_role_label': 'Rol:',
  'briefing.persona_temperament_label': 'Temperamento:',
  'briefing.persona_role_participant': 'Participante',
  'briefing.persona_temperament_challenging': 'Exigente / Urgente',
  'briefing.competency_matrix_title': 'Matriz de Competencias de Evaluación',
  'briefing.rubric_weight': 'Ponderación',
  'briefing.rubric_empathy': 'Empatía y Escucha Activa',
  'briefing.rubric_resolution': 'Resolución de Problemas',
  'briefing.rubric_compliance': 'Cumplimiento y Protocolo',
  'briefing.rules_title': 'Reglas de Interacción',
  'briefing.rule1_title': 'Habla Natural Requerida',
  'briefing.rule1_desc': 'Hable con claridad como lo haría en una llamada telefónica real con un cliente.',
  'briefing.rule2_title': 'IA Interactiva en Tiempo Real',
  'briefing.rule2_desc': 'El personaje de IA responderá dinámicamente según sus preguntas y empatía.',
  'briefing.rule3_title': 'Privacidad y Telemetría de Video',
  'briefing.rule3_desc': 'La telemetría de audio y video se procesa de forma segura para la evaluación y entrenamiento.',
  'briefing.language_title': 'Idioma Requerido',
  'briefing.step_1': 'Paso 1',
  'briefing.select_language_desc': 'Seleccione su idioma de conversación preferido para esta simulación:',
  'briefing.select_language_aria': 'Idioma de conversación preferido',
  'briefing.ready_badge': 'Listo',
  'briefing.readiness_title': 'Preparación del Sistema',
  'briefing.step_2': 'Paso 2',
  'briefing.auto_diagnostics': 'Diagnóstico automático en ejecución',
  'briefing.testing_button': 'Probando…',
  'briefing.rerun_all': '↻ Reejecutar Todo',
  'briefing.optional_paren': '(Opcional)',
  'briefing.compulsory_paren': '(Obligatorio)',
  'briefing.mic_subtext': 'Captura de entrada de voz',
  'briefing.camera_title': 'Cámara y Video',
  'briefing.camera_subtext': 'Telemetría de atención visual',
  'briefing.speaker_title': 'Reproducción de Altavoz',
  'briefing.speaker_subtext': 'Voz del personaje de cliente de IA',
  'briefing.sound_playing': '🔊 Reproduciendo…',
  'briefing.test_sound': '▶ Probar Sonido',
  'briefing.network_title': 'Latencia de Red',
  'briefing.network_subtext': 'Conexión con el servidor de IA',
  'briefing.status.optional': 'Opcional',
  'briefing.status.checking': 'Comprobando…',
  'briefing.status.ready': '✓ Listo',
  'briefing.status.testing': '⏳ Probando…',
  'briefing.status.optional_passed': '✓ Opcional',
  'briefing.status.failed': '⚠️ Falló',
  'briefing.status.pending': 'Pendiente',
  'briefing.status.ok': '✓ OK',
  'briefing.allowance_reached_title': 'Límite de Intentos del Escenario Alcanzado',
  'briefing.all_attempts_completed_title': 'Todos los Intentos Completados',
  'briefing.allowance_reached_desc_with_total': 'El cupo de intentos de este escenario está completamente utilizado ({{count}} de {{total}}). Solicite más intentos a su administrador.',
  'briefing.allowance_reached_desc': 'El cupo de intentos de este escenario está completamente utilizado. Solicite más intentos a su administrador.',
  'briefing.max_attempts_reached_desc': 'Ha alcanzado el número máximo de intentos permitidos ({{used}} de {{max}} completados) para esta simulación. No se pueden iniciar más intentos.',
  'briefing.allowance_reached_btn': 'Límite de Intentos Alcanzado',
  'briefing.max_attempts_reached_btn': 'Máximo de Intentos Alcanzado ({{used}}/{{max}})',
  'briefing.view_past_scorecards': 'Ver Tarjetas de Puntuación Anteriores →',
  'briefing.active_attempt_title': 'Intento Activo en Progreso',
  'briefing.active_attempt_desc': 'Ya tiene un intento activo{{attempt}} en progreso. No se permiten intentos duplicados. Puede reanudar su sesión directamente.',
  'briefing.active_attempt_number_tag': ' (Intento #{{n}})',
  'briefing.resume_in_progress': 'Reanudar Intento en Progreso →',
  'briefing.consent_text': 'Acepto la política de grabación de evaluaciones y consiento el análisis de conversación y evaluación de competencias por IA.',
  'briefing.view_terms': 'Ver Términos y Política de Consentimiento ↗',
  'briefing.running_hardware_checks': 'Ejecutando las pruebas de hardware necesarias. La sala se desbloqueará tan pronto como pasen.',
  'briefing.complete_system_checks': 'Complete las comprobaciones del sistema arriba para desbloquear la sala. Reintente las que hayan fallado.',
  'briefing.consent_required_btn': 'Consentimiento Requerido para Entrar',
  'briefing.checking_hardware_btn': 'Comprobando Hardware…',
  'briefing.complete_checks_btn': 'Completar Comprobaciones del Sistema',
  'briefing.start_note': 'El tiempo de simulación comienza inmediatamente al entrar a la sala. (Quedan {{remaining}} de {{max}} intentos)',
  'briefing.start_simulation_aria': 'Iniciar simulación',
  'briefing.launching_short': 'Iniciando…',
  'briefing.attempt_in_progress_short': 'Intento en progreso',
  'briefing.dock_step_consent': 'Paso 3 · consentimiento requerido',
  'briefing.dock_step_hardware': 'Paso 2 · pruebas de hardware',
  'briefing.dock_ready': 'Listo para iniciar',
  'briefing.dock_ready_to_resume': 'Sesión lista para reanudar',
  'briefing.dock_attempts_left': 'Quedan {{remaining}} de {{max}} intentos',
  'briefing.dock_resume_btn': 'Reanudar Intento →',
  'briefing.dock_consent_btn': 'Revisar y consentir ↓',
  'briefing.dock_checks_btn': 'Completar pruebas ↓',
  'briefing.dock_enter_btn': 'Entrar a la Sala →',
  'briefing.overlay_resuming_title': 'Reanudando su simulación…',
  'briefing.overlay_preparing_title': 'Preparando su sala de simulación…',
  'briefing.overlay_desc': 'Creando el intento, bloqueando su configuración de voz y cargando el escenario. Esto puede tardar unos segundos; mantenga esta pestaña abierta.',
  'briefing.overlay_cancel': 'Cancelar y permanecer aquí',

  // Scenario List Stats (admin-stats-grid)
  'scenarios.stats.total': 'Escenarios Totales',
  'scenarios.stats.total_sub': 'Casos de simulación creados',
  'scenarios.stats.published': 'Publicados y Activos',
  'scenarios.stats.published_sub': 'En vivo para práctica de alumnos',
  'scenarios.stats.draft': 'En Creación de Borrador',
  'scenarios.stats.draft_sub': 'Configuración en progreso',

  // Analytics Stats (admin-stats-grid)
  'analytics.stats.total_attempts': 'Total de Intentos de Simulación',
  'analytics.stats.avg_score': 'Puntuación Media de Competencia',
  'analytics.stats.avg_score_sub': 'En todos los intentos evaluados',
  'analytics.stats.pass_rate': 'Tasa de Aprobación de Referencia',
  'analytics.stats.pass_rate_sub': 'Umbral estándar de referencia: 70%',
  'analytics.stats.active_scenarios': 'Escenarios Activos',
  'analytics.stats.total_scenarios_sub': 'casos diseñados totales',

  // Audit Log Stats (admin-stats-grid)
  'audit.stats.total_events': 'Total de Eventos Registrados',
  'audit.stats.successful_auth': 'Autorizaciones Exitosas',
  'audit.stats.user_mutations': 'Mutaciones de Usuario y Rol',
  'audit.stats.scenario_ops': 'Operaciones de Escenario',

  // Tenant Details Stats (admin-stats-grid)
  'tenant.stats.users': 'Usuarios',
  'tenant.stats.scenarios': 'Escenarios',
  'tenant.stats.attempts_run': 'Intentos Realizados',

  // Video Observations Extended
  'scorecard.face_centering': 'Centrado de Rostro',
  'scorecard.sampled_frames': 'Fotogramas Muestreados',
  'scorecard.model_confidence': 'Confianza del Modelo',
  'scorecard.missing_intervals': '{{count}} intervalos perdidos',
  'scorecard.framing_alignment': 'Alineación de zona de encuadre',
  'scorecard.optimal_positioning': 'Posicionamiento óptimo de la cámara',
  'scorecard.framing_omitted': 'Telemetría de encuadre omitida',
  'scorecard.valid_samples': '100% de muestras válidas',
  'scorecard.failed_samples': '{{count}} muestras fallidas',
  'scorecard.detection_certainty': 'Certeza de detección',
  'scorecard.no_face_intervals': 'Intervalos sin Rostro ({{count}})',
  'scorecard.no_face_desc': 'Intervalos en los que el alumno estuvo fuera de cuadro',
  'scorecard.interval_num': 'Intervalo #{{num}}: {{start}} – {{end}}',
  'scorecard.duration_sec': '{{sec}}s de duración',
  'scorecard.warning_tag': '(Advertencia)',
  'scorecard.head_pose_title': 'Observaciones de Postura de Cabeza',
  'scorecard.supported': 'Soportado',
  'scorecard.unsupported': 'No soportado',
  'scorecard.within_limits': 'Dentro de los Límites',
  'scorecard.avg_angles': 'Promedio Guiñada / Cabeceo / Alabeo',
  'scorecard.max_rotation': 'Rotación Máxima',
  'scorecard.facial_expressions_title': 'Expresiones Faciales Aproximadas (face-api.js)',
  'scorecard.on_device_outputs': 'Salidas del Modelo en el Dispositivo',
  'scorecard.assessment_integrity_notice': 'Aviso de Integridad de la Evaluación: Las métricas físicas de la cámara reflejan el encuadre y la confianza de detección en el dispositivo. Se proporcionan únicamente como contexto de observación y no alteran las calificaciones de competencia conversacional.',
  'scorecard.telemetry_not_recorded': 'La telemetría de video no se registró durante esta sesión (solo audio de micrófono). Las métricas visuales como el encuadre y el centrado de la cara se omiten de este cuadro de mando sin penalización a su puntaje de competencia.',
  'scorecard.audio_recorded_evaluated': 'Audio Grabado y Evaluado',
  'scorecard.verbal_competency_intact': 'Competencia Verbal Intacta',
  'scorecard.retrieving_telemetry': 'Recuperando telemetría de evidencia de video...',
  'scorecard.video_failed_desc': 'No se pudo completar el análisis de video para este intento.',
  'scorecard.head_pose_unsupported': 'La estimación de postura de la cabeza no es compatible o los ángulos no estaban disponibles.',
  'scorecard.facial_notice': 'Aviso: Las etiquetas de expresión facial son observaciones aproximadas del modelo local. Son independientes de la evaluación del diálogo y no aumentan ni disminuyen directamente los puntajes de competencia.',

  // Communication & Delivery Grid
  'scorecard.comm_delivery_title': 'Comunicación y entrega',
  'scorecard.from_voice_and_transcript': 'De tu voz y transcripción',
  'scorecard.speaking_pace': 'Ritmo de habla',
  'scorecard.words_per_min': 'palabras/min',
  'scorecard.ideal_pace': '130 - 160 Ideal',
  'scorecard.filler_words_title': 'Palabras de relleno y pausas',
  'scorecard.total_fillers': 'total · {{fpm}}/min',
  'scorecard.view_evidence': '🔍 Ver',
  'scorecard.turn_taking_title': 'Equilibrio de turnos',
  'scorecard.learner_share': 'Estudiante',
  'scorecard.customer_share': 'Cliente',
  'scorecard.listening_ratio': 'Proporción de escucha',
  'scorecard.clarity_articulation': 'Claridad y articulación',
  'scorecard.response_latency': 'Latencia de respuesta',
  'scorecard.interruptions_overlaps': 'Superposición de voz',
  'scorecard.emotional_tone': 'Tono emocional',
  'scorecard.energy_engagement': 'Energía y compromiso',
  'scorecard.status_good': 'Bueno',
  'scorecard.status_watch': 'Atención',
  'scorecard.status_needs_work': 'Requiere trabajo',

  // Replay & Key Moments Card
  'scorecard.replay_moments_title': 'Reproducción y Momentos Clave',
  'scorecard.replay_moments_subtitle': 'Revise los giros cruciales de su conversación con reproducción interactiva y consejos de coaching',
  'scorecard.waveform_mode': 'Forma de onda',
  'scorecard.video_player_mode': 'Reproductor de video',
  'scorecard.filter_all': 'Todos los momentos ({{count}})',
  'scorecard.filter_improvement': 'Requiere trabajo',
  'scorecard.filter_strength': 'Fortaleza',
  'scorecard.ai_customer': 'Cliente IA',
  'scorecard.learner_you': 'Tú (Estudiante)',
  'scorecard.play_moment': 'Reproducir Momento',
  'scorecard.pause_moment': 'Pausar',
  'scorecard.jump_to_moment': 'Ir al Momento',
  'scorecard.coach_recommendation': 'Recomendación del Coach',
  'scorecard.targeted_drill': 'Microejercicio Dirigido',
  'scorecard.practice_drill': 'Practicar este turno',
  'scorecard.customer_prompt': 'Declaración del Cliente',
  'scorecard.what_you_said': 'Lo que dijiste',
  'scorecard.speed_1x': '1.0x',
  'scorecard.speed_125x': '1.25x',
  'scorecard.speed_15x': '1.5x',
  'scorecard.no_moments_found': 'No se registraron momentos clave para este filtro.',

  // Conversation Transcript Card
  'scorecard.transcript_title': 'Transcripción de la conversación',
  'scorecard.transcript_sub': 'Haga clic para cargar los turnos textuales',
  'scorecard.show_transcript': 'Mostrar Transcripción',
  'scorecard.hide_transcript': 'Ocultar Transcripción',
  'scorecard.all_turns': 'Todos los Turnos ({{count}})',
  'scorecard.learner_turns': 'Estudiante ({{count}})',
  'scorecard.ai_turns': 'Persona IA ({{count}})',
  'scorecard.open_full_modal': 'Abrir en Modal Completo ↗',
  'scorecard.turn_n': 'Turno #{{n}}',
  'scorecard.empty_turns_filter': 'No se registraron turnos para este filtro.',

  // Transcript Viewer Modal
  'scorecard.modal_transcript_title': 'Transcripción de Comunicación de Diálogo',
  'scorecard.modal_transcript_sub': 'Turnos textuales grabados durante la simulación en vivo',
  'scorecard.copy_transcript_text': '📋 Copiar Texto',
  'scorecard.transcript_copied': '✓ Copiado',
  'scorecard.close_modal': 'Cerrar',
  'scorecard.total_turns_count': 'Total de Turnos de Diálogo: {{count}}',

  // Inspect Prompts Modal
  'scorecard.inspect_prompts_title': 'Inspeccionar Instrucciones LLM y Evidencia',
  'scorecard.inspect_prompts_sub': 'Audite las instrucciones del sistema, las transcripciones y los criterios de rúbrica enviados al evaluador LLM',
  'scorecard.tab_input_data': '📥 Datos de entrada al LLM ({{count}} turnos)',
  'scorecard.tab_system_instruction': 'Instrucción del Sistema',
  'scorecard.tab_evaluated_rubrics': 'Rúbricas Evaluadas ({{count}})',
  'scorecard.tab_raw_response': 'Salida JSON en bruto',
  'scorecard.copy_prompts_json': '📋 Copiar JSON de Instrucción',
  'scorecard.prompts_copied': '✓ JSON Copiado',
  'scorecard.eval_provider_label': 'Proveedor de Evaluación:',

  // Evaluation Status & Result Error
  'scorecard.scoring_dialogue_title': 'Calificando el Diálogo de la Simulación…',
  'scorecard.eval_processing_title': 'Procesamiento de Evaluación',
  'scorecard.eval_processing_desc': 'El motor de evaluación de IA está analizando la transcripción de su conversación frente a las rúbricas de competencias y los puntos de referencia.',
  'scorecard.evaluating_in_progress': 'Evaluando transcripción...',
  'scorecard.check_status_btn': 'Comprobar Estado de Evaluación',
  'scorecard.error_results_unavailable': 'Resultados de Evaluación No Disponibles',
  'scorecard.error_default_msg': 'No se pudieron recuperar los resultados de la evaluación para este intento. Compruebe su conexión de red e inténtelo de nuevo.',
  'scorecard.my_attempts_nav': 'Mis Intentos',
  'scorecard.scoring_evaluating_msg': 'Puntuando y evaluando el desempeño de tu intento...',
  'scorecard.results_generating_msg': 'Se están generando los resultados de la evaluación del intento...',
};

